export interface WorkspaceChange {
  operation?: string
  customerIds?: string[]
  orderIds?: number[]
  actionIds?: string[]
}

/** One bounded invalidation per burst. Hidden tabs catch up once when shown. */
export function createLiveRefreshQueue(deliver: (changes: WorkspaceChange[]) => void, delay = 200) {
  let changes: WorkspaceChange[] = []
  let timer: ReturnType<typeof setTimeout> | undefined
  let active = true
  let disposed = false
  function flush() {
    timer = undefined
    if (!active || disposed || !changes.length) return
    const batch = changes
    changes = []
    deliver(batch)
  }
  function schedule() {
    if (active && !disposed && changes.length && timer === undefined) timer = setTimeout(flush, delay)
  }
  return {
    enqueue(change: WorkspaceChange) {
      if (disposed) return
      // A broad catch-up replaces oversized queues without losing invalidations.
      if (changes.length >= 100 || changes.some(item => !item.operation)) changes = [{}]
      else if (!changes.some(item => JSON.stringify(item) === JSON.stringify(change))) changes.push(change)
      schedule()
    },
    setActive(value: boolean) {
      active = value
      if (!active && timer !== undefined) { clearTimeout(timer); timer = undefined }
      if (active) schedule()
    },
    dispose() { disposed = true; changes = []; if (timer !== undefined) clearTimeout(timer) },
  }
}

export function viewTopics(pathname: string): string[] {
  if (pathname === '/') return ['dashboard']
  if (pathname.startsWith('/actions')) return ['actions', 'presence']
  if (pathname === '/customers') return ['customers']
  const customer = pathname.match(/^\/customers\/([\da-f-]{36})(?:\/|$)/i)
    ?? pathname.match(/^\/orders\/new\/([\da-f-]{36})(?:\/|$)/i)
  if (customer) return ['customer', `customer:${customer[1].toLowerCase()}`]
  if (pathname === '/orders') return ['orders']
  return []
}
